import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface AgreementDialogData {
  practiceName: string;
  address: string;
  signerName: string;
}

@Component({
  selector: 'lib-agreement-confirmation-modal',
  templateUrl: './agreement-confirmation-modal.component.html',
  styleUrls: ['./agreement-confirmation-modal.component.scss'],
  imports: [TranslateModule],
})
export class AgreementConfirmationDialogComponent {
  public dialogData: AgreementDialogData = inject(DIALOG_DATA);
  private readonly dialogRef = inject(DialogRef);

  public onBackClick(): void {
    this.dialogRef.close(false);
  }

  public onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
